$(function () {
    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel, .phone').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')
    $('.form-cpf').mask('000.000.000-00')
    $('.form-cnpj').mask('00.000.000/0000-00')

    // Floating Labels in CF7
    var formControls = document.querySelectorAll(
        '.wpcf7 .form-control, .wpcf7 .form-select'
    )

    for (var i = 0; i < formControls.length; i++) {
        var input = formControls[i]
        var label = input.parentNode.parentNode.querySelector('label')

        input.addEventListener('focus', function () {
            this.parentNode.parentNode.classList.add('active')
        })

        input.addEventListener('blur', function () {
            var cval = this.value
            if (cval.length < 1) {
                this.parentNode.parentNode.classList.remove('active')
            }
        })

        if (label) {
            label.addEventListener('click', function () {
                var input = this.parentNode.querySelector(
                    '.form-control, .form-select'
                )
                input.focus()
            })
        }
    }

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left
        var containerWidth = $('.container').outerWidth()
        var windowWidth = $(window).width()
        var offsetRight = windowWidth - (containerOffset + containerWidth)

        if ($(window).width() >= 992) {
            $('.offcanvas-offset-left').css(
                'padding-left',
                containerOffset + 12
            )
            $('.offcanvas-offset-right').css('padding-right', offsetRight + 12)
        } else {
            $('.offcanvas-offset-left').css('padding-left', '')
            $('.offcanvas-offset-right').css('padding-right', '')
        }
        $('.container-offset').css('width', containerOffset)
    }

    // Smooth Scrolling to Anchor Links
    $('.smooth-scroll').bind('click', function (event) {
        var $anchor = $(this)

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr('href')).offset().top - 300,
                },
                100
            )

        event.preventDefault()
    })

    // Fancybox
    Fancybox.bind('[data-fancybox]', {})

    // DataTables — Diretório do Google Drive
    document.querySelectorAll('.drive-directory-table').forEach(function (table) {
        $(table).DataTable({
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.0.8/i18n/pt-BR.json',
            },
            pageLength: 10,
            order: [[3, 'desc']],
            columnDefs: [
                { targets: 1, className: 'text-nowrap' },
                { targets: 2, className: 'text-nowrap' },
                { targets: 3, type: 'date', className: 'text-nowrap' },
            ],
        })
    })

    // Banner Swiper
    const bannerSwiper = new Swiper('.banner-swiper', {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.banner-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    })

    // Galeria Swiper
    const galeriaSwiper = new Swiper('.galeria-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 24,
            },
        },
        navigation: {
            nextEl: '.galeria-swiper .swiper-button-next',
            prevEl: '.galeria-swiper .swiper-button-prev',
        },
        pagination: {
            el: '.galeria-swiper .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<span class="' + className + '">' + (index + 1) + '</span>'
                )
            },
        },
    })

    // Initialize Bootstrap tooltips
    const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
    )
    const tooltipList = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    )

    // Pop-up Novo (Adicionar Página/Usuário)
    const btnAdicionarPagina = document.getElementById('btnAdicionarPagina')
    const popUpNovo = document.querySelector('.pop-up-novo')
    const btnFecharPopUp = popUpNovo
        ? popUpNovo.querySelector('button[data-bs-dismiss="offcanvas"]')
        : null

    if (btnAdicionarPagina && popUpNovo) {
        btnAdicionarPagina.addEventListener('click', function () {
            popUpNovo.style.transform = 'translateX(0)'
        })
    }

    if (btnFecharPopUp && popUpNovo) {
        btnFecharPopUp.addEventListener('click', function (e) {
            e.preventDefault()
            popUpNovo.style.transform = 'translateX(100%)'
        })
    }

    $('.menu-item-trigger').on('click', function () {
        $('#menuDetailTitle').html('Carregando...')
        $('#menuDetailDescription').html(
            '<img src="/assets/img/loader.svg" alt="Carregando..." width="80" />'
        )
        $('#menuDetailLink').attr('href', '')
        $('#menuDetailImage').attr('src', '')
        $('#menuDetailBox').show()
        $('#menuDetailLinks').html('')
        $('.menuLinks').hide()
        $('#btn-adicionar-pagina').addClass('d-none')
        ;($.post(
            '/',
            {
                a: 'menudata',
                area: $(this).attr('data-menu'),
            },
            function (data) {
                $('#menuDetailTitle').html(data.area)
                $('#menuDetailDescription').html(data.descricao)
                $('#menuDetailLink').attr('href', '/area/' + data.slug)
                if (data.imagem) {
                    $('#menuDetailImage').attr('src', data.imagem)
                } else {
                    $('#menuDetailImage').attr(
                        'src',
                        '/assets/img/placeholder_1.jpg'
                    )
                }

                $('.menuLinks').show()
                console.log(data.paginas)
                if (data.paginas.length > 0) {
                    var linksHtml = ''
                    data.paginas.forEach(function (pagina) {
                        linksHtml +=
                            '<li><a href="/pagina/' +
                            pagina.slug +
                            '" class="font-size-16 font-500 color-preto text-decoration-none">' +
                            pagina.titulo +
                            '</a></li>'
                    })
                    $('#menuDetailLinks').html(linksHtml)
                }
                if (data.admin) {
                    $('#btn-adicionar-pagina').removeClass('d-none')
                    $('#adicionarPaginaAreaId').val(data.id)
                } else {
                    $('#btn-adicionar-pagina').addClass('d-none')
                    $('#adicionarPaginaAreaId').val('')
                }
            }
        ),
            'json')
    })

    $('#menuDetailBack').on('click', function () {
        $('#menuDetailBox').hide()
    })

    $('#menuOffcanvas').on('hidden.bs.offcanvas', function () {
        $('#menuDetailBox').hide()
    })

    const btnAdicionarPaginaMenu = document.getElementById('btnAdicionarPaginaMenu')
    const popUpAdicionarPagina = document.getElementById('popUpAdicionarPagina')
    const btnFecharAdicionarPagina = document.getElementById('btnFecharAdicionarPagina')
    const btnCancelarAdicionarPagina = document.getElementById('btnCancelarAdicionarPagina')
    const popUpAdicionarNoticia     = document.getElementById('popUpAdicionarNoticia')
    const popUpEditarNoticia        = document.getElementById('popUpEditarNoticia')

    function criarBackdropPopUp() {
        if (document.getElementById('popUpBackdrop')) return
        const backdrop = document.createElement('div')
        backdrop.id = 'popUpBackdrop'
        backdrop.className = 'offcanvas-backdrop fade show'
        backdrop.addEventListener('click', fecharTodosPopUps)
        document.body.appendChild(backdrop)
        document.body.style.overflow = 'hidden'
    }

    function removerBackdropPopUp() {
        const backdrop = document.getElementById('popUpBackdrop')
        if (backdrop) backdrop.remove()
        document.body.style.overflow = ''
    }

    function fecharTodosPopUps() {
        ;[
            popUpAdicionarPagina,
            popUpAdicionarNoticia,
            popUpEditarNoticia,
        ].forEach(function (popup) {
            if (popup) popup.style.transform = 'translateX(100%)'
        })
        removerBackdropPopUp()
    }

    var driveTypes = {
        album: {
            titulo:      '&#128194; Álbum do Google Drive',
            placeholderClass: 'drive-gallery-placeholder',
            placeholderLabel: 'Álbum do Google Drive',
            cor:         '#4285f4',
        },
        directory: {
            titulo:      '&#128193; Diretório do Google Drive',
            placeholderClass: 'drive-directory-placeholder',
            placeholderLabel: 'Diretório do Google Drive',
            cor:         '#0f9d58',
        },
    }

    function abrirModalGoogleDrive(context, tipo) {
        var cfg      = driveTypes[tipo] || driveTypes.album
        var existing = document.getElementById('modalGoogleDrive')
        if (existing) existing.remove()

        var modal = document.createElement('div')
        modal.id = 'modalGoogleDrive'
        modal.innerHTML = [
            '<div style="position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99999;display:flex;align-items:center;justify-content:center;">',
            '  <div style="background:#fff;border-radius:10px;padding:28px;width:500px;max-width:92vw;box-shadow:0 8px 40px rgba(0,0,0,.25)">',
            '    <h5 style="margin:0 0 18px;font-weight:700;font-size:17px;">' + cfg.titulo + '</h5>',
            '    <div style="margin-bottom:14px;">',
            '      <label style="font-size:13px;color:#555;display:block;margin-bottom:6px;">Link da pasta do Google Drive</label>',
            '      <input type="text" id="driveUrlInput" style="width:100%;padding:9px 12px;border:1px solid #ccc;border-radius:6px;font-size:14px;box-sizing:border-box;" placeholder="https://drive.google.com/drive/folders/...">',
            '    </div>',
            '    <div id="driveFeedback" style="font-size:13px;min-height:18px;margin-bottom:14px;"></div>',
            '    <div style="display:flex;gap:8px;justify-content:flex-end;">',
            '      <button id="driveCancelar" style="padding:8px 18px;border:1px solid #ccc;background:#fff;border-radius:6px;cursor:pointer;font-size:14px;">Cancelar</button>',
            '      <button id="driveConfirmar" style="padding:8px 18px;background:' + cfg.cor + ';color:#fff;border:none;border-radius:6px;cursor:pointer;font-weight:700;font-size:14px;">Verificar e inserir</button>',
            '    </div>',
            '  </div>',
            '</div>',
        ].join('')
        document.body.appendChild(modal)
        document.getElementById('driveUrlInput').focus()

        document.getElementById('driveCancelar').addEventListener('click', function () {
            modal.remove()
        })

        document.getElementById('driveConfirmar').addEventListener('click', function () {
            var url      = document.getElementById('driveUrlInput').value.trim()
            var feedback = document.getElementById('driveFeedback')
            var btn      = this

            if (!url) {
                feedback.innerHTML = '<span style="color:red;">Informe o link da pasta.</span>'
                return
            }

            btn.disabled    = true
            btn.textContent = 'Verificando...'
            feedback.innerHTML = ''

            $.post('/pagina', { a: 'previewDrive', url: url }, function (data) {
                if (data.stt) {
                    var label = data.total + ' arquivo' + (data.total !== 1 ? 's' : '') + ' encontrado' + (data.total !== 1 ? 's' : '')
                    var html  = '<div class="' + cfg.placeholderClass + '"'
                        + ' data-folder-id="' + data.folderId + '"'
                        + ' contenteditable="false"'
                        + ' style="background:#f0faf4;border:2px dashed ' + cfg.cor + ';border-radius:8px;padding:20px;text-align:center;margin:16px 0;cursor:default;">'
                        + '&#128194; <strong>' + cfg.placeholderLabel + '</strong> &mdash; ' + label
                        + '</div>'
                    context.invoke('editor.pasteHTML', html)
                    modal.remove()
                } else {
                    var msg = data.msg || 'Erro ao acessar a pasta.'
                    if (data.level === 'warning') {
                        feedback.innerHTML = '<div style="background:#fff3cd;border:1px solid #ffc107;color:#664d03;padding:10px;border-radius:6px;">' + msg + '</div>'
                    } else {
                        feedback.innerHTML = '<span style="color:red;">' + msg + '</span>'
                    }
                    btn.disabled    = false
                    btn.textContent = 'Verificar e inserir'
                }
            }, 'json').fail(function () {
                feedback.innerHTML = '<span style="color:red;">Erro de comunicação com o servidor.</span>'
                btn.disabled    = false
                btn.textContent = 'Verificar e inserir'
            })
        })
    }

    function criarBotaoGoogleDrive(context) {
        var ui     = $.summernote.ui
        var button = ui.button({
            contents: '<span style="font-size:12px;font-weight:600;">&#128194; Álbum do Google Drive</span>',
            tooltip:  'Inserir Álbum do Google Drive',
            click: function () { abrirModalGoogleDrive(context, 'album') },
        })
        return button.render()
    }

    function criarBotaoDiretorioDrive(context) {
        var ui     = $.summernote.ui
        var button = ui.button({
            contents: '<span style="font-size:12px;font-weight:600;">&#128193; Diretório do Google Drive</span>',
            tooltip:  'Inserir Diretório do Google Drive',
            click: function () { abrirModalGoogleDrive(context, 'directory') },
        })
        return button.render()
    }

    function criarBotaoPowerBI(context) {
        var ui = $.summernote.ui
        var button = ui.button({
            contents: '<span style="font-size:12px;font-weight:600">&#9654; PowerBI</span>',
            tooltip: 'Inserir Player do PowerBI',
            click: function () {
                var titulo = window.prompt('Título do Dashboard PowerBI:')
                if (!titulo) return
                var link = window.prompt('Link do Dashboard PowerBI:')
                if (!link) return
                var html = '<h1>' + titulo + '</h1>\n<iframe title="' + titulo + '" width="1024" height="790" src="' + link + '" frameborder="0" allowFullScreen="true"></iframe>\n<hr>'
                context.invoke('editor.pasteHTML', html)
            },
        })
        return button.render()
    }

    var summernoteIniciado = false

    function iniciarSummernote() {
        if (summernoteIniciado) return
        summernoteIniciado = true
        $('#adicionarPaginaConteudo').summernote({
            lang: 'pt-BR',
            height: 250,
            codeviewFilter: false,
            codeviewIframeFilter: false,
            buttons: { powerbi: criarBotaoPowerBI, googledrive: criarBotaoGoogleDrive, diretoriodrive: criarBotaoDiretorioDrive },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
                ['powerbi', ['powerbi']],
                ['googledrive', ['googledrive']],
                ['diretoriodrive', ['diretoriodrive']],
                ['view', ['fullscreen', 'codeview']],
            ],
        })
    }

    function abrirPopUpAdicionarPagina() {
        if (!popUpAdicionarPagina) return
        criarBackdropPopUp()
        popUpAdicionarPagina.style.transform = 'translateX(0)'
        iniciarSummernote()
    }

    if (btnAdicionarPaginaMenu && popUpAdicionarPagina) {
        btnAdicionarPaginaMenu.addEventListener('click', function () {
            const menuOffcanvasEl = document.getElementById('menuOffcanvas')
            const menuOffcanvas =
                bootstrap.Offcanvas.getInstance(menuOffcanvasEl)

            if (menuOffcanvas) {
                menuOffcanvasEl.addEventListener(
                    'hidden.bs.offcanvas',
                    function () {
                        criarBackdropPopUp()
                    },
                    { once: true }
                )
                menuOffcanvas.hide()
            }

            popUpAdicionarPagina.style.transform = 'translateX(0)'
            iniciarSummernote()
        })
    }

    const btnAdicionarNoticiaMenu = document.getElementById('btnAdicionarNoticiaMenu')
    if (btnAdicionarNoticiaMenu && popUpAdicionarNoticia) {
        btnAdicionarNoticiaMenu.addEventListener('click', function () {
            const menuOffcanvasEl = document.getElementById('menuOffcanvas')
            const menuOffcanvas   = bootstrap.Offcanvas.getInstance(menuOffcanvasEl)
            if (menuOffcanvas) {
                menuOffcanvasEl.addEventListener('hidden.bs.offcanvas', function () {
                    criarBackdropPopUp()
                }, { once: true })
                menuOffcanvas.hide()
            }
            const areaId = document.getElementById('adicionarPaginaAreaId')?.value || ''
            abrirPopUpAdicionarNoticia(areaId)
        })
    }

    const btnAdicionarPaginaPage = document.getElementById('btnAdicionarPaginaPage')

    if (btnAdicionarPaginaPage && popUpAdicionarPagina) {
        btnAdicionarPaginaPage.addEventListener('click', function () {
            document.getElementById('adicionarPaginaAreaId').value = this.dataset.areaId
            abrirPopUpAdicionarPagina()
        })
    }

    function fecharPopUpAdicionarPagina() {
        if (popUpAdicionarPagina) {
            popUpAdicionarPagina.style.transform = 'translateX(100%)'
        }
        removerBackdropPopUp()
    }

    if (btnFecharAdicionarPagina) {
        btnFecharAdicionarPagina.addEventListener('click', fecharPopUpAdicionarPagina)
    }

    if (btnCancelarAdicionarPagina) {
        btnCancelarAdicionarPagina.addEventListener('click', fecharPopUpAdicionarPagina)
    }

    function setupSeletorUsuarios(config) {
        const { inputBusca, divResultados, divTags, checkPublica, container } = config
        if (!inputBusca || !divResultados || !divTags || !checkPublica || !container) return

        const selecionados = []

        function toggleContainer() {
            container.classList.toggle('d-none', checkPublica.checked)
        }

        function renderTags() {
            divTags.innerHTML = ''
            selecionados.forEach(function (u) {
                const tag = document.createElement('span')
                tag.className = 'usuario-tag'
                tag.innerHTML =
                    u.nome +
                    ' <button type="button" aria-label="Remover">&times;</button>'
                tag.querySelector('button').addEventListener('click', function () {
                    const idx = selecionados.findIndex(function (x) { return x.id === u.id })
                    if (idx > -1) selecionados.splice(idx, 1)
                    renderTags()
                })
                divTags.appendChild(tag)
            })
        }

        function adicionarUsuario(u) {
            if (selecionados.find(function (x) { return x.id === u.id })) return
            selecionados.push(u)
            renderTags()
            inputBusca.value = ''
            divResultados.classList.add('d-none')
        }

        function mostrarResultados(items) {
            divResultados.innerHTML = ''
            if (!items.length) {
                divResultados.classList.add('d-none')
                return
            }
            items.forEach(function (u) {
                const item = document.createElement('div')
                item.className = 'usuarios-autocomplete-item'
                item.textContent = u.nome + ' (' + u.email + ')'
                item.addEventListener('click', function () {
                    adicionarUsuario({ id: u.id, nome: u.nome })
                })
                divResultados.appendChild(item)
            })
            divResultados.classList.remove('d-none')
        }

        var buscaTimer
        inputBusca.addEventListener('input', function () {
            const q = this.value.trim()
            clearTimeout(buscaTimer)
            if (q.length < 2) {
                divResultados.classList.add('d-none')
                return
            }
            buscaTimer = setTimeout(function () {
                $.post('/pagina', { a: 'searchUsuarios', q: q }, mostrarResultados, 'json')
            }, 300)
        })

        document.addEventListener('click', function (e) {
            if (!container.contains(e.target)) {
                divResultados.classList.add('d-none')
            }
        })

        checkPublica.addEventListener('change', toggleContainer)
        toggleContainer()

        return {
            getIds: function () { return selecionados.map(function (u) { return u.id }) },
            setUsuarios: function (list) { list.forEach(adicionarUsuario) },
        }
    }

    var seletorAdicionarPagina = setupSeletorUsuarios({
        inputBusca:   document.getElementById('adicionarPaginaBuscarUsuario'),
        divResultados: document.getElementById('adicionarPaginaResultadosUsuario'),
        divTags:      document.getElementById('adicionarPaginaTagsUsuario'),
        checkPublica: document.getElementById('adicionarPaginaPublica'),
        container:    document.getElementById('adicionarPaginaUsuariosContainer'),
    })

    var seletorEditarPagina = setupSeletorUsuarios({
        inputBusca:   document.getElementById('editarPaginaBuscarUsuario'),
        divResultados: document.getElementById('editarPaginaResultadosUsuario'),
        divTags:      document.getElementById('editarPaginaTagsUsuario'),
        checkPublica: document.getElementById('editarPaginaPublica'),
        container:    document.getElementById('editarPaginaUsuariosContainer'),
    })

    var containerEditar = document.getElementById('editarPaginaUsuariosContainer')
    if (seletorEditarPagina && containerEditar && containerEditar.dataset.usuarios) {
        seletorEditarPagina.setUsuarios(JSON.parse(containerEditar.dataset.usuarios))
    }

    function setupSeletorGrupos(config) {
        const { inputBusca, divTags, checkPublica, container } = config
        if (!inputBusca || !divTags || !checkPublica || !container) return

        const selecionados = []

        function toggleContainer() {
            container.classList.toggle('d-none', checkPublica.checked)
        }

        function renderTags() {
            divTags.innerHTML = ''
            selecionados.forEach(function (grupo) {
                const tag = document.createElement('span')
                tag.className = 'usuario-tag'
                tag.innerHTML = grupo + ' <button type="button" aria-label="Remover">&times;</button>'
                tag.querySelector('button').addEventListener('click', function () {
                    const idx = selecionados.indexOf(grupo)
                    if (idx > -1) selecionados.splice(idx, 1)
                    renderTags()
                })
                divTags.appendChild(tag)
            })
        }

        function adicionarGrupo(email) {
            email = (email || '').trim().toLowerCase()
            if (!email || selecionados.indexOf(email) !== -1) return
            selecionados.push(email)
            renderTags()
            inputBusca.value = ''
        }

        inputBusca.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ',') {
                e.preventDefault()
                adicionarGrupo(this.value)
            }
        })

        inputBusca.addEventListener('blur', function () {
            if (this.value.trim()) adicionarGrupo(this.value)
        })

        checkPublica.addEventListener('change', toggleContainer)
        toggleContainer()

        return {
            getGrupos: function () { return selecionados.slice() },
            setGrupos: function (list) { list.forEach(adicionarGrupo) },
        }
    }

    var seletorGruposAdicionar = setupSeletorGrupos({
        inputBusca:   document.getElementById('adicionarPaginaBuscarGrupo'),
        divTags:      document.getElementById('adicionarPaginaTagsGrupo'),
        checkPublica: document.getElementById('adicionarPaginaPublica'),
        container:    document.getElementById('adicionarPaginaGruposContainer'),
    })

    var seletorGruposEditar = setupSeletorGrupos({
        inputBusca:   document.getElementById('editarPaginaBuscarGrupo'),
        divTags:      document.getElementById('editarPaginaTagsGrupo'),
        checkPublica: document.getElementById('editarPaginaPublica'),
        container:    document.getElementById('editarPaginaGruposContainer'),
    })

    var containerGruposEditar = document.getElementById('editarPaginaGruposContainer')
    if (seletorGruposEditar && containerGruposEditar && containerGruposEditar.dataset.grupos) {
        seletorGruposEditar.setGrupos(JSON.parse(containerGruposEditar.dataset.grupos))
    }

    const inputTituloPagina = document.getElementById('adicionarPaginaTitulo')
    const inputSlugPagina = document.getElementById('adicionarPaginaSlug')

    function gerarSlug(texto) {
        return texto
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
    }

    if (inputTituloPagina && inputSlugPagina) {
        inputTituloPagina.addEventListener('input', function () {
            inputSlugPagina.value = gerarSlug(this.value)
        })
    }

    const formAdicionarPagina = document.getElementById('formAdicionarPagina')
    if (formAdicionarPagina) {
        formAdicionarPagina.addEventListener('submit', function (e) {
            e.preventDefault()

            const areaId = document.getElementById(
                'adicionarPaginaAreaId'
            ).value
            const titulo = document
                .getElementById('adicionarPaginaTitulo')
                .value.trim()
            const descricao = document
                .getElementById('adicionarPaginaDescricao')
                .value.trim()
            const conteudo = $('#adicionarPaginaConteudo').summernote('code')
            const publica = document.getElementById('adicionarPaginaPublica')
                .checked
                ? 1
                : 0
            const feedback = document.getElementById(
                'formAdicionarPaginaFeedback'
            )

            feedback.className = 'mb-3'
            feedback.textContent = ''

            const usuariosAdicionar = seletorAdicionarPagina ? seletorAdicionarPagina.getIds() : []
            const gruposAdicionar   = seletorGruposAdicionar ? seletorGruposAdicionar.getGrupos() : []

            const formData = new FormData()
            formData.append('a', 'addPagina')
            formData.append('vic_area_id', areaId)
            formData.append('titulo', titulo)
            formData.append('descricao', descricao)
            formData.append('conteudo', conteudo)
            formData.append('publica', publica)
            usuariosAdicionar.forEach(function (uid) { formData.append('usuarios[]', uid) })
            gruposAdicionar.forEach(function (g) { formData.append('grupos[]', g) })
            const thumbInput = document.getElementById('adicionarPaginaThumb')
            if (thumbInput && thumbInput.files[0]) {
                formData.append('thumb', thumbInput.files[0])
            }

            $.ajax({
                url: '/pagina',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        feedback.classList.add('color-verde')
                        feedback.textContent = 'Página adicionada com sucesso!'
                        document.getElementById('adicionarPaginaTitulo').value = ''
                        document.getElementById('adicionarPaginaDescricao').value = ''
                        $('#adicionarPaginaConteudo').summernote('reset')
                        if (thumbInput) thumbInput.value = ''
                        setTimeout(fecharPopUpAdicionarPagina, 1200)
                    } else {
                        feedback.classList.add('color-vermelho')
                        feedback.textContent = data.msg || 'Erro ao adicionar página.'
                    }
                },
            })
        })
    }

    // Editar página
    const btnEditarPagina = document.getElementById('btnEditarPagina')
    const popUpEditarPagina = document.getElementById('popUpEditarPagina')
    const btnFecharEditarPagina = document.getElementById('btnFecharEditarPagina')
    const btnCancelarEditarPagina = document.getElementById('btnCancelarEditarPagina')
    var summernoteEditIniciado = false

    function fecharPopUpEditarPagina() {
        if (popUpEditarPagina) {
            popUpEditarPagina.style.transform = 'translateX(100%)'
        }
        removerBackdropPopUp()
    }

    function iniciarSummernoteEdit() {
        if (summernoteEditIniciado || !window.summernoteEditId) return
        summernoteEditIniciado = true
        $('#' + window.summernoteEditId).summernote({
            lang: 'pt-BR',
            height: 250,
            codeviewFilter: false,
            codeviewIframeFilter: false,
            buttons: { powerbi: criarBotaoPowerBI, googledrive: criarBotaoGoogleDrive, diretoriodrive: criarBotaoDiretorioDrive },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
                ['powerbi', ['powerbi']],
                ['googledrive', ['googledrive']],
                ['diretoriodrive', ['diretoriodrive']],
                ['view', ['fullscreen', 'codeview']],
            ],
        })
    }

    if (btnEditarPagina && popUpEditarPagina) {
        btnEditarPagina.addEventListener('click', function () {
            popUpEditarPagina.style.transform = 'translateX(0)'
            iniciarSummernoteEdit()
        })
    }

    if (btnFecharEditarPagina) {
        btnFecharEditarPagina.addEventListener('click', fecharPopUpEditarPagina)
    }

    if (btnCancelarEditarPagina) {
        btnCancelarEditarPagina.addEventListener('click', fecharPopUpEditarPagina)
    }

    const inputTituloEditarPagina = document.getElementById('editarPaginaTitulo')
    const inputSlugEditarPagina = document.getElementById('editarPaginaSlug')
    if (inputTituloEditarPagina && inputSlugEditarPagina) {
        inputTituloEditarPagina.addEventListener('input', function () {
            inputSlugEditarPagina.value = gerarSlug(this.value)
        })
    }

    const formEditarPagina = document.getElementById('formEditarPagina')
    if (formEditarPagina) {
        formEditarPagina.addEventListener('submit', function (e) {
            e.preventDefault()

            const feedback = document.getElementById('formEditarPaginaFeedback')
            feedback.className = 'mb-3'
            feedback.textContent = ''

            const conteudo = window.summernoteEditId
                ? $('#' + window.summernoteEditId).summernote('code')
                : document.querySelector('[name="conteudo"]').value

            const usuariosEditar = seletorEditarPagina ? seletorEditarPagina.getIds() : []
            const gruposEditar   = seletorGruposEditar ? seletorGruposEditar.getGrupos() : []

            const formData = new FormData()
            formData.append('a', 'editPagina')
            formData.append('id', formEditarPagina.querySelector('[name="id"]').value)
            formData.append('vic_area_id', formEditarPagina.querySelector('[name="vic_area_id"]').value)
            formData.append('titulo', document.getElementById('editarPaginaTitulo').value.trim())
            formData.append('slug', document.getElementById('editarPaginaSlug').value)
            formData.append('descricao', document.getElementById('editarPaginaDescricao').value.trim())
            formData.append('conteudo', conteudo)
            formData.append('publica', document.getElementById('editarPaginaPublica').checked ? 1 : 0)
            usuariosEditar.forEach(function (uid) { formData.append('usuarios[]', uid) })
            gruposEditar.forEach(function (g) { formData.append('grupos[]', g) })

            const thumbInput = document.getElementById('editarPaginaThumb')
            if (thumbInput && thumbInput.files[0]) {
                formData.append('thumb', thumbInput.files[0])
            }

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        feedback.classList.add('color-verde')
                        feedback.textContent = 'Página atualizada com sucesso!'
                        setTimeout(function () {
                            window.location.href = '/pagina/' + data.slug
                        }, 1200)
                    } else {
                        feedback.classList.add('color-vermelho')
                        feedback.textContent = data.msg || 'Erro ao salvar página.'
                    }
                },
            })
        })
    }

    // Excluir página
    const btnExcluirPagina = document.getElementById('btnExcluirPagina')
    if (btnExcluirPagina) {
        btnExcluirPagina.addEventListener('click', function () {
            if (!confirm('Tem certeza que deseja excluir esta página? Esta ação não pode ser desfeita.')) return

            const btn = this
            const pageId = btn.dataset.id
            const redirect = btn.dataset.redirect

            btn.disabled = true

            $.post(
                window.location.pathname,
                { a: 'deletePagina', id: pageId },
                function (data) {
                    if (data.stt) {
                        window.location.href = redirect
                    } else {
                        btn.disabled = false
                        const feedback = document.getElementById('formEditarPaginaFeedback')
                        if (feedback) {
                            feedback.className = 'mb-3 color-vermelho'
                            feedback.textContent = data.msg || 'Erro ao excluir página.'
                        }
                    }
                },
                'json'
            )
        })
    }

    // Adicionar Notícia
    const btnFecharAdicionarNoticia   = document.getElementById('btnFecharAdicionarNoticia')
    const btnCancelarAdicionarNoticia = document.getElementById('btnCancelarAdicionarNoticia')
    var summernoteNoticiaIniciado = false

    function fecharPopUpAdicionarNoticia() {
        if (popUpAdicionarNoticia) {
            popUpAdicionarNoticia.style.transform = 'translateX(100%)'
        }
        removerBackdropPopUp()
    }

    function iniciarSummernoteNoticia() {
        if (summernoteNoticiaIniciado) return
        summernoteNoticiaIniciado = true
        $('#adicionarNoticiaTexto').summernote({
            lang: 'pt-BR',
            height: 250,
            codeviewFilter: false,
            codeviewIframeFilter: false,
            buttons: { powerbi: criarBotaoPowerBI, googledrive: criarBotaoGoogleDrive, diretoriodrive: criarBotaoDiretorioDrive },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
                ['powerbi', ['powerbi']],
                ['googledrive', ['googledrive']],
                ['diretoriodrive', ['diretoriodrive']],
                ['view', ['fullscreen', 'codeview']],
            ],
        })
    }

    function abrirPopUpAdicionarNoticia(areaId) {
        if (!popUpAdicionarNoticia) return
        document.getElementById('adicionarNoticiaAreaId').value = areaId || ''
        criarBackdropPopUp()
        popUpAdicionarNoticia.style.transform = 'translateX(0)'
        iniciarSummernoteNoticia()
    }

    if (btnFecharAdicionarNoticia) {
        btnFecharAdicionarNoticia.addEventListener('click', fecharPopUpAdicionarNoticia)
    }

    if (btnCancelarAdicionarNoticia) {
        btnCancelarAdicionarNoticia.addEventListener('click', fecharPopUpAdicionarNoticia)
    }

    const inputTituloNoticia = document.getElementById('adicionarNoticiaTitulo')
    const inputSlugNoticia   = document.getElementById('adicionarNoticiaSlug')
    if (inputTituloNoticia && inputSlugNoticia) {
        inputTituloNoticia.addEventListener('input', function () {
            inputSlugNoticia.value = gerarSlug(this.value)
        })
    }

    const formAdicionarNoticia = document.getElementById('formAdicionarNoticia')
    if (formAdicionarNoticia) {
        formAdicionarNoticia.addEventListener('submit', function (e) {
            e.preventDefault()

            const feedback = document.getElementById('formAdicionarNoticiaFeedback')
            feedback.className = 'mb-3'
            feedback.textContent = ''

            const formData = new FormData()
            formData.append('a', 'addNoticia')
            formData.append('vic_area_id', document.getElementById('adicionarNoticiaAreaId').value)
            formData.append('titulo', document.getElementById('adicionarNoticiaTitulo').value.trim())
            formData.append('slug', document.getElementById('adicionarNoticiaSlug').value)
            formData.append('descricao', document.getElementById('adicionarNoticiaDescricao').value.trim())
            formData.append('texto', $('#adicionarNoticiaTexto').summernote('code'))
            const imagemInput = document.getElementById('adicionarNoticiaImagem')
            if (imagemInput && imagemInput.files[0]) {
                formData.append('imagem', imagemInput.files[0])
            }

            $.ajax({
                url: '/noticias',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        feedback.classList.add('color-verde')
                        feedback.textContent = 'Notícia adicionada com sucesso!'
                        document.getElementById('adicionarNoticiaTitulo').value = ''
                        document.getElementById('adicionarNoticiaDescricao').value = ''
                        document.getElementById('adicionarNoticiaSlug').value = ''
                        $('#adicionarNoticiaTexto').summernote('reset')
                        if (imagemInput) imagemInput.value = ''
                        setTimeout(fecharPopUpAdicionarNoticia, 1200)
                    } else {
                        feedback.classList.add('color-vermelho')
                        feedback.textContent = data.msg || 'Erro ao adicionar notícia.'
                    }
                },
            })
        })
    }

    window.abrirPopUpAdicionarNoticia = abrirPopUpAdicionarNoticia

    // Editar Notícia
    const btnFecharEditarNoticia  = document.getElementById('btnFecharEditarNoticia')
    const btnCancelarEditarNoticia = document.getElementById('btnCancelarEditarNoticia')
    var summernoteEditNoticiaIniciado = false

    function fecharPopUpEditarNoticia() {
        if (popUpEditarNoticia) popUpEditarNoticia.style.transform = 'translateX(100%)'
        removerBackdropPopUp()
    }

    function iniciarSummernoteEditNoticia() {
        if (summernoteEditNoticiaIniciado) return
        summernoteEditNoticiaIniciado = true
        $('#editarNoticiaTexto').summernote({
            lang: 'pt-BR',
            height: 250,
            codeviewFilter: false,
            codeviewIframeFilter: false,
            buttons: { powerbi: criarBotaoPowerBI, googledrive: criarBotaoGoogleDrive, diretoriodrive: criarBotaoDiretorioDrive },
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['insert', ['link']],
                ['powerbi', ['powerbi']],
                ['googledrive', ['googledrive']],
                ['diretoriodrive', ['diretoriodrive']],
                ['view', ['fullscreen', 'codeview']],
            ],
        })
    }

    if (btnFecharEditarNoticia)   btnFecharEditarNoticia.addEventListener('click', fecharPopUpEditarNoticia)
    if (btnCancelarEditarNoticia) btnCancelarEditarNoticia.addEventListener('click', fecharPopUpEditarNoticia)

    const inputTituloEditarNoticia = document.getElementById('editarNoticiaTitulo')
    const inputSlugEditarNoticia   = document.getElementById('editarNoticiaSlug')
    if (inputTituloEditarNoticia && inputSlugEditarNoticia) {
        inputTituloEditarNoticia.addEventListener('input', function () {
            inputSlugEditarNoticia.value = gerarSlug(this.value)
        })
    }

    document.addEventListener('click', function (e) {
        // Editar
        const btnEditar = e.target.closest('.js-editar-noticia')
        if (btnEditar) {
            const d = btnEditar.dataset
            document.getElementById('editarNoticiaId').value         = d.id
            document.getElementById('editarNoticiaAreaId').value     = d.areaId
            document.getElementById('editarNoticiaTitulo').value     = d.titulo
            document.getElementById('editarNoticiaSlug').value       = d.slug
            document.getElementById('editarNoticiaDescricao').value  = d.descricao
            document.getElementById('editarNoticiaImagemAtual').value = d.imagem

            const preview = document.getElementById('editarNoticiaImagemPreview')
            preview.innerHTML = d.imagem
                ? '<img src="' + d.imagem + '" style="max-height:80px;border-radius:4px;" class="mb-1">'
                : ''

            iniciarSummernoteEditNoticia()
            $('#editarNoticiaTexto').summernote('code', d.texto)

            criarBackdropPopUp()
            popUpEditarNoticia.style.transform = 'translateX(0)'
        }

        // Excluir
        const btnExcluir = e.target.closest('.js-excluir-noticia')
        if (btnExcluir) {
            if (!confirm('Excluir notícia?')) return
            const id       = btnExcluir.dataset.id
            const redirect = btnExcluir.dataset.redirect || null
            const item     = btnExcluir.closest('.noticia-item')
            $.post('/noticias', { a: 'deleteNoticia', id: id }, function (data) {
                if (data.stt) {
                    if (redirect) {
                        window.location.href = redirect
                    } else {
                        item.remove()
                    }
                } else {
                    alert(data.msg || 'Erro ao excluir notícia.')
                }
            }, 'json')
        }
    })

    const formEditarNoticia = document.getElementById('formEditarNoticia')
    if (formEditarNoticia) {
        formEditarNoticia.addEventListener('submit', function (e) {
            e.preventDefault()
            const feedback = document.getElementById('formEditarNoticiaFeedback')
            feedback.className = 'mb-3'
            feedback.textContent = ''

            const formData = new FormData()
            formData.append('a', 'editNoticia')
            formData.append('id', document.getElementById('editarNoticiaId').value)
            formData.append('vic_area_id', document.getElementById('editarNoticiaAreaId').value)
            formData.append('titulo', document.getElementById('editarNoticiaTitulo').value.trim())
            formData.append('slug', document.getElementById('editarNoticiaSlug').value)
            formData.append('descricao', document.getElementById('editarNoticiaDescricao').value.trim())
            formData.append('texto', $('#editarNoticiaTexto').summernote('code'))
            formData.append('imagem_atual', document.getElementById('editarNoticiaImagemAtual').value)
            const imagemInput = document.getElementById('editarNoticiaImagem')
            if (imagemInput && imagemInput.files[0]) formData.append('imagem', imagemInput.files[0])

            $.ajax({
                url: '/noticias',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        feedback.classList.add('color-verde')
                        feedback.textContent = 'Notícia salva com sucesso!'
                        setTimeout(function () { window.location.reload() }, 1000)
                    } else {
                        feedback.classList.add('color-vermelho')
                        feedback.textContent = data.msg || 'Erro ao salvar notícia.'
                    }
                },
            })
        })
    }

    // Comunicados
    const comunicadoInput     = document.getElementById('comunicadoInput')
    const btnEnviarComunicado = document.getElementById('btnEnviarComunicado')
    const muralRecados        = document.querySelector('.mural-recados')

    function escapeHtml(text) {
        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
    }

    function buildComunicadoItem(id, nome, data, texto) {
        return `<div class="mural-recado-item shadow-sm mb-4 background-cinza-claro p-3 rounded-3" data-id="${id}">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <div>
                    <h3 class="font-size-14 font-700 color-laranja mb-0">${escapeHtml(nome)}</h3>
                    <span class="font-size-12 color-cinza">${escapeHtml(data)}</span>
                </div>
                <div class="dropdown">
                    <button class="btn p-0 border-0 background-transparent" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="icon-detalhes color-cinza" aria-hidden="true"></i>
                    </button>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item d-flex align-items-center gap-2 py-2 px-3 font-size-14 js-editar-comunicado" href="#"><i class="icon-editar"></i>Editar</a></li>
                        <li><a class="dropdown-item d-flex align-items-center gap-2 py-2 px-3 font-size-14 js-excluir-comunicado" href="#"><i class="icon-excluir"></i>Excluir</a></li>
                    </ul>
                </div>
            </div>
            <div class="mural-recado-texto font-size-16 color-preto mt-2">${escapeHtml(texto)}</div>
        </div>`
    }

    if (btnEnviarComunicado && comunicadoInput) {
        function enviarComunicado() {
            const texto  = comunicadoInput.value.trim()
            const areaId = comunicadoInput.dataset.areaId

            if (!texto) return

            btnEnviarComunicado.disabled = true

            $.post(
                window.location.pathname,
                { a: 'addComunicado', vic_area_id: areaId, comunicado: texto },
                function (data) {
                    if (data.stt) {
                        comunicadoInput.value = ''
                        if (muralRecados) {
                            muralRecados.insertAdjacentHTML('afterbegin', buildComunicadoItem(data.id, data.nome, data.insert_date, data.comunicado))
                        }
                    }
                    btnEnviarComunicado.disabled = false
                },
                'json'
            )
        }

        btnEnviarComunicado.addEventListener('click', enviarComunicado)

        comunicadoInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') enviarComunicado()
        })
    }

    if (muralRecados) {
        const comunicadoItems = muralRecados.querySelectorAll('.mural-recado-item')
        if (comunicadoItems.length > 3) {
            let altura = 0
            for (let i = 0; i < 3; i++) {
                altura += comunicadoItems[i].offsetHeight + parseFloat(window.getComputedStyle(comunicadoItems[i]).marginBottom)
            }
            muralRecados.style.maxHeight = altura + 'px'
        }

        $(muralRecados).on('click', '.js-editar-comunicado', function (e) {
            e.preventDefault()

            const item          = $(this).closest('.mural-recado-item')[0]
            const textoDiv      = item.querySelector('.mural-recado-texto')
            const textoOriginal = textoDiv.textContent.trim()

            textoDiv.innerHTML = `<textarea class="form-control font-size-14 mt-2" rows="3">${escapeHtml(textoOriginal)}</textarea>
                <div class="d-flex gap-2 mt-2">
                    <button type="button" class="btn btn-sm background-azul color-white js-salvar-comunicado">Salvar</button>
                    <button type="button" class="btn btn-sm background-white border-1 color-preto js-cancelar-comunicado">Cancelar</button>
                </div>`

            item.querySelector('.js-salvar-comunicado').addEventListener('click', function () {
                const novoTexto = item.querySelector('textarea').value.trim()
                if (!novoTexto) return

                this.disabled = true

                $.post(
                    window.location.pathname,
                    { a: 'editComunicado', id: item.dataset.id, comunicado: novoTexto },
                    function (data) {
                        if (data.stt) {
                            textoDiv.className = 'mural-recado-texto font-size-16 color-preto mt-2'
                            textoDiv.textContent = data.comunicado
                        }
                    },
                    'json'
                )
            })

            item.querySelector('.js-cancelar-comunicado').addEventListener('click', function () {
                textoDiv.className = 'mural-recado-texto font-size-16 color-preto mt-2'
                textoDiv.textContent = textoOriginal
            })
        })

        $(muralRecados).on('click', '.js-excluir-comunicado', function (e) {
            e.preventDefault()

            if (!confirm('Excluir este comunicado?')) return

            const item = $(this).closest('.mural-recado-item')[0]

            $.post(
                window.location.pathname,
                { a: 'deleteComunicado', id: item.dataset.id },
                function (data) {
                    if (data.stt) item.remove()
                },
                'json'
            )
        })
    }

    // Arquivos da área
    const btnAdicionarArquivo   = document.getElementById('btnAdicionarArquivo')
    const popUpAdicionarArquivo = document.getElementById('popUpAdicionarArquivo')
    const btnFecharAdicionarArquivo  = document.getElementById('btnFecharAdicionarArquivo')
    const btnCancelarAdicionarArquivo = document.getElementById('btnCancelarAdicionarArquivo')

    function abrirPopUpAdicionarArquivo() {
        if (popUpAdicionarArquivo) {
            criarBackdropPopUp()
            popUpAdicionarArquivo.style.transform = 'translateX(0)'
        }
    }

    function fecharPopUpAdicionarArquivo() {
        if (popUpAdicionarArquivo) {
            popUpAdicionarArquivo.style.transform = ''
            removerBackdropPopUp()
        }
    }

    if (btnAdicionarArquivo) {
        btnAdicionarArquivo.addEventListener('click', abrirPopUpAdicionarArquivo)
    }
    if (btnFecharAdicionarArquivo) {
        btnFecharAdicionarArquivo.addEventListener('click', fecharPopUpAdicionarArquivo)
    }
    if (btnCancelarAdicionarArquivo) {
        btnCancelarAdicionarArquivo.addEventListener('click', fecharPopUpAdicionarArquivo)
    }

    const formAdicionarArquivo = document.getElementById('formAdicionarArquivo')
    if (formAdicionarArquivo) {
        formAdicionarArquivo.addEventListener('submit', function (e) {
            e.preventDefault()

            const link    = document.getElementById('adicionarArquivoLink').value.trim()
            const arquivo = document.getElementById('adicionarArquivoFile').files.length

            if (!link && !arquivo) {
                const feedback = document.getElementById('formAdicionarArquivoFeedback')
                feedback.className = 'mb-3 color-vermelho'
                feedback.textContent = 'Informe um link externo ou anexe um arquivo.'
                return
            }

            const feedback   = document.getElementById('formAdicionarArquivoFeedback')
            const submitBtn  = formAdicionarArquivo.querySelector('[type="submit"]')
            submitBtn.disabled = true
            feedback.className = 'mb-3 d-none'

            const formData = new FormData(formAdicionarArquivo)
            formData.append('a', 'addArquivo')

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        window.location.reload()
                    } else {
                        feedback.className = 'mb-3 color-vermelho'
                        feedback.textContent = data.msg || 'Erro ao salvar arquivo.'
                        submitBtn.disabled = false
                    }
                }
            })
        })
    }

    $(document).on('click', '.js-excluir-arquivo', function () {
        if (!confirm('Excluir este arquivo?')) return

        const item = $(this).closest('.arquivo-item')[0]

        $.post(
            window.location.pathname,
            { a: 'deleteArquivo', id: item.dataset.id },
            function (data) {
                if (data.stt) item.remove()
            },
            'json'
        )
    })

    // Softwares e serviços
    const btnAdicionarSoftware        = document.getElementById('btnAdicionarSoftware')
    const popUpAdicionarSoftware      = document.getElementById('popUpAdicionarSoftware')
    const btnFecharAdicionarSoftware  = document.getElementById('btnFecharAdicionarSoftware')
    const btnCancelarAdicionarSoftware = document.getElementById('btnCancelarAdicionarSoftware')

    function abrirPopUpAdicionarSoftware() {
        if (popUpAdicionarSoftware) {
            criarBackdropPopUp()
            popUpAdicionarSoftware.style.transform = 'translateX(0)'
        }
    }

    function fecharPopUpAdicionarSoftware() {
        if (popUpAdicionarSoftware) {
            popUpAdicionarSoftware.style.transform = ''
            removerBackdropPopUp()
        }
    }

    if (btnAdicionarSoftware) {
        btnAdicionarSoftware.addEventListener('click', abrirPopUpAdicionarSoftware)
    }
    if (btnFecharAdicionarSoftware) {
        btnFecharAdicionarSoftware.addEventListener('click', fecharPopUpAdicionarSoftware)
    }
    if (btnCancelarAdicionarSoftware) {
        btnCancelarAdicionarSoftware.addEventListener('click', fecharPopUpAdicionarSoftware)
    }

    const formAdicionarSoftware = document.getElementById('formAdicionarSoftware')
    if (formAdicionarSoftware) {
        formAdicionarSoftware.addEventListener('submit', function (e) {
            e.preventDefault()

            const feedback  = document.getElementById('formAdicionarSoftwareFeedback')
            const submitBtn = formAdicionarSoftware.querySelector('[type="submit"]')
            submitBtn.disabled = true
            feedback.className = 'mb-3 d-none'

            const formData = new FormData(formAdicionarSoftware)
            formData.append('a', 'addSoftware')

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        window.location.reload()
                    } else {
                        feedback.className = 'mb-3 color-vermelho'
                        feedback.textContent = data.msg || 'Erro ao salvar software.'
                        submitBtn.disabled = false
                    }
                }
            })
        })
    }

    $(document).on('click', '.js-excluir-software', function () {
        if (!confirm('Excluir este software?')) return

        const item = $(this).closest('.software-item')[0]

        $.post(
            window.location.pathname,
            { a: 'deleteSoftware', id: item.dataset.id, vic_area_id: item.dataset.areaId },
            function (data) {
                if (data.stt) item.remove()
            },
            'json'
        )
    })

    // CRUD de perguntas frequentes
    const btnAdicionarFaq  = document.getElementById('btnAdicionarFaq')
    const popUpFaq         = document.getElementById('popUpFaq')
    const btnFecharFaq     = document.getElementById('btnFecharFaq')
    const btnCancelarFaq   = document.getElementById('btnCancelarFaq')

    function abrirPopUpFaq(id, pergunta, resposta) {
        if (!popUpFaq) return
        document.getElementById('faqId').value       = id       || ''
        document.getElementById('faqPergunta').value = pergunta || ''
        document.getElementById('faqResposta').value = resposta || ''
        document.getElementById('popUpFaqTitulo').textContent = id ? 'Editar Pergunta' : 'Adicionar Pergunta'
        document.getElementById('formFaqFeedback').className  = 'mb-3 d-none'
        const submitBtn = document.querySelector('#formFaq [type="submit"]')
        if (submitBtn) submitBtn.disabled = false
        criarBackdropPopUp()
        popUpFaq.style.transform = 'translateX(0)'
    }

    function fecharPopUpFaq() {
        if (!popUpFaq) return
        popUpFaq.style.transform = ''
        removerBackdropPopUp()
    }

    if (btnAdicionarFaq) {
        btnAdicionarFaq.addEventListener('click', function () { abrirPopUpFaq() })
    }
    if (btnFecharFaq) {
        btnFecharFaq.addEventListener('click', fecharPopUpFaq)
    }
    if (btnCancelarFaq) {
        btnCancelarFaq.addEventListener('click', fecharPopUpFaq)
    }

    const formFaq = document.getElementById('formFaq')
    if (formFaq) {
        formFaq.addEventListener('submit', function (e) {
            e.preventDefault()

            const feedback  = document.getElementById('formFaqFeedback')
            const submitBtn = formFaq.querySelector('[type="submit"]')
            const id        = document.getElementById('faqId').value

            submitBtn.disabled = true
            feedback.className = 'mb-3 d-none'

            $.post(
                window.location.pathname,
                {
                    a:          id ? 'editFaq' : 'addFaq',
                    id:         id,
                    vic_area_id: formFaq.querySelector('[name="vic_area_id"]').value,
                    pergunta:   document.getElementById('faqPergunta').value.trim(),
                    resposta:   document.getElementById('faqResposta').value.trim()
                },
                function (data) {
                    if (data.stt) {
                        if (id) {
                            const item = document.querySelector('.faq-item[data-id="' + id + '"]')
                            if (item) {
                                item.querySelector('.accordion-button').textContent = data.pergunta
                                item.querySelector('.faq-resposta').textContent     = data.resposta
                            }
                        } else {
                            window.location.reload()
                        }
                        fecharPopUpFaq()
                    } else {
                        feedback.className = 'mb-3 color-vermelho'
                        feedback.textContent = data.msg || 'Erro ao salvar.'
                        submitBtn.disabled = false
                    }
                },
                'json'
            ).fail(function () {
                feedback.className = 'mb-3 color-vermelho'
                feedback.textContent = 'Erro ao salvar.'
                submitBtn.disabled = false
            })
        })
    }

    $(document).on('click', '.js-editar-faq', function (e) {
        e.preventDefault()
        const item     = $(this).closest('.faq-item')[0]
        const id       = item.dataset.id
        const pergunta = item.querySelector('.accordion-button').textContent.trim()
        const resposta = item.querySelector('.faq-resposta').textContent.trim()
        abrirPopUpFaq(id, pergunta, resposta)
    })

    $(document).on('click', '.js-excluir-faq', function (e) {
        e.preventDefault()
        if (!confirm('Excluir esta pergunta?')) return

        const item = $(this).closest('.faq-item')[0]

        $.post(
            window.location.pathname,
            { a: 'deleteFaq', id: item.dataset.id },
            function (data) {
                if (data.stt) item.remove()
            },
            'json'
        )
    })

    // Busca de perguntas frequentes
    const perguntaKeyword = document.getElementById('pergunta-keyword')
    if (perguntaKeyword) {
        perguntaKeyword.addEventListener('input', function () {
            const keyword = this.value.trim().toLowerCase()
            const items   = document.querySelectorAll('#accordionPerguntas1 .accordion-item')

            items.forEach(function (item) {
                const pergunta = item.querySelector('.accordion-header button').textContent.toLowerCase()
                const resposta = item.querySelector('.accordion-body').textContent.toLowerCase()
                item.style.display = (!keyword || pergunta.includes(keyword) || resposta.includes(keyword)) ? '' : 'none'
            })
        })
    }

    $('.links-rapidos-categoria').on('click', function (e) {
        e.preventDefault()

        var categoriaId = $(this).data('categoria-id')

        if (!$('#links-lista-' + categoriaId).hasClass('d-none')) {
            $('.links-rapidos-lista').addClass('d-none')
            $(this)
                .find('i')
                .removeClass('icon-arrow-up')
                .addClass('icon-arrow-down')
            return
        } else {
            $('.links-rapidos-categoria')
                .find('i')
                .removeClass('icon-arrow-up')
                .addClass('icon-arrow-down')

            $(this)
                .find('i')
                .removeClass('icon-arrow-down')
                .addClass('icon-arrow-up')

            // Ocultar todas as listas de links
            $('.links-rapidos-lista').addClass('d-none')

            // Mostrar a lista de links correspondente à categoria clicada
            $('#links-lista-' + categoriaId).removeClass('d-none')
        }
    })
    // Menu Detail Box

    const menuItemTriggers = document.querySelectorAll('.menu-item-trigger')
    const menuDetailBox = document.getElementById('menuDetailBox')
    const menuDetailTitle = document.getElementById('menuDetailTitle')
    const menuDetailDescription = document.getElementById(
        'menuDetailDescription'
    )
    const menuDetailLink = document.getElementById('menuDetailLink')
    const menuDetailImage = document.getElementById('menuDetailImage')
    const menuDetailLinks = document.getElementById('menuDetailLinks')
    const menuOffcanvas = document.getElementById('menuOffcanvas')
    /*
    if (menuItemTriggers.length > 0 && typeof menuData !== 'undefined') {
        menuItemTriggers.forEach((trigger) => {
            trigger.addEventListener('mouseover', function () {
                const menuId = this.getAttribute('data-menu')
                const data = menuData[menuId]

                if (data) {
                    menuDetailTitle.textContent = data.titulo
                    menuDetailDescription.textContent = data.descricao
                    menuDetailLink.href = data.url
                    menuDetailImage.src = data.imagem

                    // Popular links
                    menuDetailLinks.innerHTML = ''
                    if (data.links && data.links.length > 0) {
                        data.links.forEach((link) => {
                            const li = document.createElement('li')
                            const a = document.createElement('a')
                            a.href = link.url
                            a.className =
                                'font-size-16 font-500 color-preto text-decoration-none'
                            a.textContent = link.titulo
                            li.appendChild(a)
                            menuDetailLinks.appendChild(li)
                        })
                    }

                    menuDetailBox.style.display = 'block'
                }
            })
        })
    }
    */

    // Fechar menu detail box quando o offcanvas fechar
    if (menuOffcanvas && menuDetailBox) {
        menuOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
            menuDetailBox.style.display = 'none'
        })
    }

    // CRUD de colaboradores do organograma
    const btnAdicionarColaborador    = document.getElementById('btnAdicionarColaborador')
    const popUpColaborador           = document.getElementById('popUpColaborador')
    const btnFecharColaborador       = document.getElementById('btnFecharColaborador')
    const btnCancelarColaborador     = document.getElementById('btnCancelarColaborador')

    function abrirPopUpColaborador(id, colaborador, email, whatsapp, funcao, foto) {
        if (!popUpColaborador) return
        document.getElementById('colaboradorId').value        = id          || ''
        document.getElementById('colaboradorNome').value      = colaborador  || ''
        document.getElementById('colaboradorFuncao').value    = funcao       || ''
        document.getElementById('colaboradorEmail').value     = email        || ''
        document.getElementById('colaboradorFotoAtual').value = foto         || ''
        $('#colaboradorWhatsapp').val(whatsapp || '').trigger('input')
        document.getElementById('popUpColaboradorTitulo').textContent = id ? 'Editar Colaborador' : 'Adicionar Colaborador'
        document.getElementById('formColaboradorFeedback').className  = 'mb-3 d-none'
        const submitBtn = document.querySelector('#formColaborador [type="submit"]')
        if (submitBtn) submitBtn.disabled = false
        criarBackdropPopUp()
        popUpColaborador.style.transform = 'translateX(0)'
    }

    function fecharPopUpColaborador() {
        if (!popUpColaborador) return
        popUpColaborador.style.transform = ''
        removerBackdropPopUp()
    }

    if (btnAdicionarColaborador) {
        btnAdicionarColaborador.addEventListener('click', function () { abrirPopUpColaborador() })
    }
    if (btnFecharColaborador) {
        btnFecharColaborador.addEventListener('click', fecharPopUpColaborador)
    }
    if (btnCancelarColaborador) {
        btnCancelarColaborador.addEventListener('click', fecharPopUpColaborador)
    }

    const formColaborador = document.getElementById('formColaborador')
    if (formColaborador) {
        formColaborador.addEventListener('submit', function (e) {
            e.preventDefault()

            const feedback  = document.getElementById('formColaboradorFeedback')
            const submitBtn = formColaborador.querySelector('[type="submit"]')
            const id        = document.getElementById('colaboradorId').value

            submitBtn.disabled = true
            feedback.className = 'mb-3 d-none'

            const formData = new FormData(formColaborador)
            formData.append('a', id ? 'editOrganograma' : 'addOrganograma')

            $.ajax({
                url: window.location.pathname,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function (data) {
                    if (data.stt) {
                        window.location.reload()
                    } else {
                        feedback.className = 'mb-3 color-vermelho'
                        feedback.textContent = data.msg || 'Erro ao salvar.'
                        submitBtn.disabled = false
                    }
                }
            }).fail(function () {
                feedback.className = 'mb-3 color-vermelho'
                feedback.textContent = 'Erro ao salvar.'
                submitBtn.disabled = false
            })
        })
    }

    $(document).on('click', '.js-editar-colaborador', function (e) {
        e.preventDefault()
        const item = $(this).closest('.organograma-item')[0]
        abrirPopUpColaborador(
            item.dataset.id,
            item.dataset.colaborador,
            item.dataset.email,
            item.dataset.whatsapp,
            item.dataset.funcao,
            item.dataset.foto
        )
    })

    $(document).on('click', '.js-excluir-colaborador', function () {
        if (!confirm('Excluir este colaborador?')) return

        const item = $(this).closest('.organograma-item')[0]

        $.post(
            window.location.pathname,
            { a: 'deleteOrganograma', id: item.dataset.id },
            function (data) {
                if (data.stt) item.remove()
            },
            'json'
        )
    })
})

// Toggle Select All Checkboxes
window.toggleSelectAll = function (checkbox) {
    const checkboxes = document.querySelectorAll('.user-checkbox')
    checkboxes.forEach((cb) => {
        cb.checked = checkbox.checked
    })
}

// Toggle Sort Direction
window.toggleSort = function () {
    const sortIcon = document.getElementById('sortIcon')
    const table = document.querySelector('.usuarios-table')
    const rows = Array.from(table.querySelectorAll('.user-row'))

    const isAscending = sortIcon.classList.contains('icon-sort-ascending')

    // Sort rows by name
    rows.sort((a, b) => {
        const nameA = a.querySelector('.user-name').textContent.trim()
        const nameB = b.querySelector('.user-name').textContent.trim()
        return isAscending
            ? nameA.localeCompare(nameB)
            : nameB.localeCompare(nameA)
    })

    // Reappend rows in sorted order
    rows.forEach((row) => table.appendChild(row))

    // Toggle icon
    if (isAscending) {
        sortIcon.classList.remove('icon-sort-ascending')
        sortIcon.classList.add('icon-sort-descending')
    } else {
        sortIcon.classList.remove('icon-sort-descending')
        sortIcon.classList.add('icon-sort-ascending')
    }
}
